import { compose } from '../laxer';
import { IAstNode, IBetweenAndAstNode, IComparisonAstNode } from '../typings/ast-node';
import { IAstOptions } from '../index.d';
import { generateTokens } from '../token/index';


interface IFunctionArgumentOption {
  functionCode: string;
  argumentIndex: number;
}

interface IPosition {
  line: number;
  start: number;
  end: number;
}

/**
 * 获取表达式中指定函数的指定参数的位置
 * @param input 表达式
 * @param options 生成Token的参数
 * @param faOptions 函数信息配置
 */
export function getFunctionArgumentPositions(
  input: string,
  options: IAstOptions,
  faOptions: IFunctionArgumentOption
) {

  const positions: IPosition[] = [];

  const tokens = generateTokens(input, options);
  const ast = compose(tokens);

  traverseAstNode(ast, (node) => {
    if (node && node.type === 'FunctionCall' && node.value === faOptions.functionCode) {
      const arg = node.args[faOptions.argumentIndex];
      if (arg && arg.token) {
        positions.push(arg.token.position);
      }
    }
  });

  return positions;
}


type ICallback = (node: IAstNode) => void;

function traverseAstNode(node: IAstNode, callback: ICallback) {
  callback(node);
  if (node.type === 'FunctionCall') {
    node.args.forEach(callback);
  } else if (node.type === 'Arithmetic') {
    callback(node.left);
    callback(node.right);
  } else if (node.type === 'LogicNot') {
    callback(node.right);
  } else if (node.type === 'Comparison') {

    callback(node.left);

    if ((node as IComparisonAstNode).right) {
      callback((node as IComparisonAstNode).right);
    }
    if ((node as IBetweenAndAstNode).andLeft) {
      callback((node as IBetweenAndAstNode).andLeft);
    }
    if ((node as IBetweenAndAstNode).andRight) {
      callback((node as IBetweenAndAstNode).andRight);
    }
  }
}
